<template>
  <div class="ac-size-check-row">
    <div class="flex-row align-center">
      <SACToggleSwitch
        :checked="toggleChecked"
        :change="toggleAll"
        :disabled="disabled"
      />
      <button
        class="all-btn"
        :disabled="disabled"
        @click="toggleAll"
      >
        {{ toggleChecked ? 'Deselect all' : 'Select all' }}
      </button>
    </div>
    <SACCheckbox
      v-for="(option, idx) in Object.keys(options)"
      :key="`${field}-${option}`"
      :field="option"
      :label="`${idx + 1}&quot;`"
      :checked="options[option]"
      :change="handleToggle"
      :disable="disabled"
    />
  </div>
</template>

<script>
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import SACToggleSwitch from '@shared/components/sac/SACToggleSwitch.vue';

export default {
  name: 'SizeCheckRow',
  components: {
    SACCheckbox,
    SACToggleSwitch,
  },
  props: {
    field: String,
    options: Object,
    onChange: Function,
    disabled: Boolean,
  },
  computed: {
    toggleChecked() {
      const optionChecked = Object.values(this.options).find((option) => option);
      return !!optionChecked;
    },
  },
  methods: {
    toggleAll() {
      this.onChange(this.field, null, !this.toggleChecked);
    },
    handleToggle(field) {
      this.onChange(this.field, field, !this.options[field]);
    },
  },
};
</script>

<style lang="scss">

.ac-size-check-row {
  display: flex;
  align-items: center;
  .all-btn {
    margin-left: 8px;
    margin-right: 16px;
    font-size: 0.875rem;
    color: $NBLUE100;
    font-weight: 500;
    line-height: 1;
    width: 80px;
    &:disabled {
      color: $N30 !important;
    }
  }
  .sac-checkbox-container {
    gap: 8px;
    margin-right: 24px;
    .sac-checkbox {
      width: 24px;
      height: 24px;
      .checkbox.active {
        width: 8px;
        height: 13px;
        left: 8px;
        top: 4px;
      }
    }
  }
}
</style>
